import { ajaxT } from 'util'
import axios from 'axios'

/**
 * 根据起点终点查询
 */
export function getSearchLine(params) {
  return ajaxT.post('manage/searchLine', params)
}
